import { render, staticRenderFns } from "./PendingApplications.vue?vue&type=template&id=5ee20dfd&scoped=true&"
import script from "./PendingApplications.vue?vue&type=script&lang=js&"
export * from "./PendingApplications.vue?vue&type=script&lang=js&"
import style0 from "./PendingApplications.vue?vue&type=style&index=0&id=5ee20dfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee20dfd",
  null
  
)

export default component.exports